import { montserrat, playfairDisplay, type Translationtype } from "utils";
import Image from "next/image";
import Link from "next/link";
import { BsStarFill } from "react-icons/bs";
import { useAppConfiguration } from "appConfig";

interface IBasicModalContentProps {
  t: Translationtype;
  locale: string;
}

export function BasicModalContent({ t, locale }: IBasicModalContentProps) {
  const appConfiguration = useAppConfiguration();

  return (
    <div className="bg-white p-3 rounded-[14px]">
      <div className="absolute right-0 bottom-0">
        <div className="relative w-[8rem] sm:w-[10rem] md:w-[10rem] lg:w-[12rem] h-[10rem] sm:h-[12rem] md:h-[12rem] lg:h-[14rem] mb-[1rem] lg:mb-[2rem]  sm:mb-0 ">
          <Image
            src="/assets/img/jinny.png"
            alt="Jinny"
            fill
            className="object-cover"
          />
        </div>
      </div>
      <h2
        className={`${playfairDisplay.className} text-xl sm:text-2xl lg:text-3xl text-start max-w-[13rem] md:max-w-[18rem] mr-auto  font-semibold`}
      >
        {t("upgradeToPremium.modal.title")}
      </h2>
      <div className="flex flex-col mr-auto my-5">
        <span
          className={`${montserrat.className}  text-sm sm:text-base md:text-lg`}
        >
          {t("upgradeToPremium.modal.learnMore")}
        </span>
        <Link
          href={`${appConfiguration.landingUrl}/${locale}/pricing` as any}
          target="_blank"
          className="text-[#806375] text-sm sm:text-base md:text-lg underline"
        >
          {t("upgradeToPremium.modal.package")}
        </Link>
      </div>
      <Link
        type="button"
        className="flex flex-row gap-2 items-center w-fit border-[#1e293b] text-xs md:text-base border-2 rounded-full px-4 py-1 text-[#1e293b] bg-[#dcc3a8] font-semibold hover:bg-[#1e293b] hover:text-white"
        href="/manageMagicAI"
      >
        <BsStarFill />
        {t("Global.activateMagicAI")}
      </Link>
    </div>
  );
}
